import { useTranslations } from "contexts/LocalizationContext";
import { ListItem, ListIcon, VStack, Text, Heading } from "@chakra-ui/react";
import { BoxImportant } from "@airhelp/icons";
import type { ListItemProps } from "./WhyChooseAirHelp.d";

const NegativeItem = ({ item }: ListItemProps) => {
  const translations = useTranslations();

  return (
    <ListItem
      display="flex"
      flexDirection={{ base: "column", md: "row" }}
      background="greyscale.300"
      p={{ base: 8, md: 0 }}
      rounded={{ base: "xl", md: "none" }}
      minWidth="255px"
    >
      <ListIcon as={BoxImportant} color="warning.400" boxSize={6} mt={1} />
      <VStack spacing={2} align="left" mt={{ base: 6, md: 0 }}>
        <Heading variant="h5" as="h5">
          {translations(item.headingTranslationKey)}
        </Heading>
        <Text fontSize="md">{translations(item.textTranslationKey)}</Text>
      </VStack>
    </ListItem>
  );
};

export default NegativeItem;
